import { Grid, Paper } from "@material-ui/core";
import React from "react";

interface ICarouselDots {
  images: string[];
  focusIndex: number;
  onClick: (i: number) => void;
  focusColor: string;
  upselling: boolean;
}

const CarouselDots = ({ images, focusIndex, onClick, focusColor, upselling }: ICarouselDots) => (
  <Grid
    container
    alignItems="center"
    justifyContent="center"
    spacing={1}
    style={{ position: "absolute", bottom: upselling ? 175 : 5, zIndex: 3 }}>
    {images.map((i, index) => {
      if (i === "") return null;
      else {
        return (
          <Grid item key={"carouselDots" + i}>
            <Paper
              elevation={focusIndex === index ? 4 : 2}
              style={{
                transitionProperty: "height, width",
                transitionDuration: "0.3s",
                height: focusIndex === index ? 14 : 10,
                width: focusIndex === index ? 14 : 10,
                borderRadius: "3pc",
                backgroundColor: focusIndex === index ? focusColor : "#eef1f1",
              }}
              onClick={() => onClick(index)}
            />
          </Grid>
        );
      }
    })}
  </Grid>
);

export default CarouselDots;
